import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  position: relative;
  
  padding: 5% 6%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center; /* 文字置中 */
  text-align: center; /* 文字置中 */


  @media (min-width: 500px) {
    padding: 5% 12% 5% 12%;
  }
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 500px) {
    display: none;
  }
  
`;

const BackgroundImage_mobile = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 500px) {
    display: block;
  }
  
`;

const Subtitle = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 0px;
  z-index: 0;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 35px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-bottom: 80px;
  z-index: 0;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 40px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; 
  flex-direction: column;
  max-width:70%;


  @media (max-width: 500px) {
    padding: 0px; 
    max-width:100%;
  }
`;

const TextWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  padding: 36px 48px 36px 48px;
  gap: 8px;
  margin-bottom: 16px;
  position: relative;
  flex: 1;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0px 0px 20px rgba(182, 176, 95, 0.4);
  border-radius: 16px;

  @media (max-width: 500px) {
    max-width: 100%;
    padding: 8px 8px;
    font-size: 14px;
    line-height: 24px;
  }
`;



const ReadMoreButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 48px;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top: 24px;
    padding: 6px 20px;
    margin: 0 auto;
  }

  &:hover {
    background-color: #FFFFFF;
    color: #1f1f1f;
  }
`;

const DAO = () => (
  <SectionWrapper>
    <BackgroundImage src="/images/DAO_Background.png" alt="DAO Background" />
    <BackgroundImage_mobile src="/images/DAO_Background_mobile.png" alt="DAO Background" />
    
    <Subtitle>Decentralized Autonomous Organization</Subtitle>
    <Title>分散式自治組織DAO</Title>
    <ContentWrapper>
      
      <TextWrapper>
        <p>DAO 是甚麼? DAO 的運行方式與傳統組織有何不同? 在社會中 DAO 可以參考過往哪些組織發展及該應該扮演何種角色？<br/><br/>DAO 在全國運行幾年後遇到了甚麼困難? 在法律上如何可能? 大量的DAO工具用途為何? 這種新型態的組織存在的可能積極意義是什麼？ 在臺灣可以怎麼發展?</p>
        <a href="/dao" style={{ textDecoration: 'none' }}><ReadMoreButton>閱讀更多</ReadMoreButton></a>
      </TextWrapper>
    </ContentWrapper>

  </SectionWrapper>
);

export default DAO;
